import styled, { css } from "styled-components";
import { lighten, darken } from "polished";
import * as colors from "../settings/colors";
import { Link } from "react-router-dom";

// prettier-ignore
const Button = styled.button`
  display: inline-block;
  padding: 0 ${({ size }) => size === "sm" ? "10px" : "16px"};
  font-size: ${({ size }) => size === "sm" ? "12px" : "14px"};
  line-height: ${({ size }) => size === "sm" ? "22px" : "30px"};
  text-align: center;
  box-sizing: border-box;
  border-radius: 4px;
  border: 1px solid ${colors.BUTTON_BORDER};
  outline: none;
  cursor: pointer;
  text-decoration: none;
  color: ${colors.TEXT};
  background: none;
  transition-property: background, border-color, color;
  transition-duration: 0.2s;

  &:focus,
  &:not([aria-disabled="true"]):focus {
    box-shadow: 0 0 0 3px #99c6f3;
  }

  &.active,
  &[aria-current="true"] {
    color: white;
    background: ${colors.BLUE};
    font-weight: 600;
    line-height: 32px;
    border: 0;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${colors.TAB_TEXT};
      border-color: ${colors.DIVIDER};
      cursor: not-allowed;
    `}

  ${({ primary, variant, disabled }) =>
    (primary || variant === "primary") &&
    !disabled &&
    css`
      color: white;
      border-color: ${colors.BLUE};
      background: ${colors.BLUE};
      font-weight: 600;

      &:hover {
        border-color: ${lighten(0.05, colors.BLUE)};
        background: ${lighten(0.05, colors.BLUE)};
      }

      &:active {
        border-color: ${darken(0.05, colors.BLUE)};
        background: ${darken(0.05, colors.BLUE)};
      }
    `};

  ${({ danger, variant, disabled }) =>
    (danger || variant === "danger") &&
    !disabled &&
    css`
      color: ${colors.RED};
      border-color: ${colors.RED};
      font-weight: 600;

      &:hover {
        color: #fff;
        background: ${colors.RED};
      }

      &:active {
        background: ${darken(0.05, colors.RED)};
      }
    `};

  ${props => props.hasIcon && css`
    display: inline-flex;
    align-items: center;
    padding: 0 ${({ size }) => size === "sm" ? "4px" : "6px"};
    height: ${({ size }) => size === "sm" ? "22px" : "30px"};
  `}
`;

export default Button;
export const LinkButton = Button.withComponent(Link);



// WEBPACK FOOTER //
// ./src/components/Button.js